var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news-detail"},[_c('top-bar'),(_vm.isMobile)?_c('mobile-nav',{attrs:{"edu":_vm.edu,"space":_vm.space}}):_vm._e(),_c('nav-bar',{attrs:{"edu":_vm.edu,"space":_vm.space}}),_c('info-detail'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }